const teamData = [
  {
    name: "Aniket Pal",
    image: require("../assets/data/aniket.jpeg").default,
    tagline: "Founder",
    github: "https://www.github.com/Aniket762",
    linkedin: "https://www.linkedin.com/in/aniket-pal/",
    instagram: "https://www.instagram.com/itzaniket_762",
  },

  {
    name: "Sneha Mallik",
    image: require("../assets/data/sneha.jpg").default,
    tagline: "Developer",
    github: "https://github.com/snehaM2210",
    linkedin: "https://www.linkedin.com/in/sneha-mallik-736170191/",
    instagram: "https://www.instagram.com/_sneham2210/",
  },
  {
    name: "Sumana Basu",
    image: require("../assets/data/sumana.jpeg").default,
    tagline: "Ex-Coordinator",
    github: "https://www.github.com/sumana2001",
    linkedin: "https://www.linkedin.com/in/sumana-basu/",
    instagram: "https://www.instagram.com/sumanasuchira",
  },
  {
    name: "Sanjeet Patro",
    image: require("../assets/data/farewell.jpg").default,
    tagline: "Design Team",
    github: "https://github.com/sanjeet-crypto",
    linkedin: "https://www.linkedin.com/in/sanjeet-patro-6a1067202/",
    instagram: "https://www.instagram.com/sanjeet_patro/",
  },
  {
    name: "Sayantan Chatterjee",
    tagline: "Mangement Team",
    image: require("../assets/data/SayantanChatterjee.jpeg").default,
    github: "https://github.com/Sayantan-Ch",
    linkedin: "https://www.linkedin.com/in/sayantan-chatterjee-400784208/",
    instagram: "https://www.instagram.com/sayantan__ch/",
  },
  {
    name: "Ankush Lohani",
    image: require("../assets/data/ankush.jpeg").default,
    tagline: "Management Team",
    github: "https://github.com/iamakl",
    linkedin: "https://www.linkedin.com/in/iamakl/",
    instagram: "https://www.instagram.com/iam__akl/",
  },
  {
    name: "Komal",
    image: require("../assets/data/komald.jpeg").default,
    tagline: "Web Developer",
    github: "https://github.com/komal1503",
    linkedin: "https://www.linkedin.com/in/komal-deegwal-35b31a206",
    instagram: "https://www.instagram.com/komal15012003/",
  },
  {
    name: "Manjeet Dhayal",
    image: require("../assets/data/manjeet.jpg").default,
    tagline: "Web Developer",
    github: "https://github.com/manjeetdhayal",
    linkedin: "https://www.linkedin.com/in/manjeet-dhayal-194953209/",
    instagram: "https://www.instagram.com/___manjeet_/",
  },
  {
    name: "Debasish Mishra",
    image: require("../assets/data/debasish.jpeg").default,
    tagline: "Web Developer",
    github: "https://github.com/debasish-creator",
    linkedin: "https://www.linkedin.com/in/debasish-mishra-86135b129/",
    instagram: "https://www.instagram.com/debasishmishra31/",
  } 
];

export default teamData;
